import React, { useEffect } from 'react';
import { HeroSection } from '../components/HeroSection';
import { PainSection } from '../components/PainSection';
import { MechanismSection } from '../components/MechanismSection';
import { PainAmplification } from '../components/PainAmplification';
import { OriginStory } from '../components/OriginStory';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { ProductPresentation } from '../components/ProductPresentation';
import { ValueStack } from '../components/ValueStack';
import { BeforeAfter } from '../components/BeforeAfter';
import { ScienceSection } from '../components/ScienceSection';
import { PricingSection } from '../components/PricingSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { UrgencySection } from '../components/UrgencySection';
import { FAQSection } from '../components/FAQSection';
import { EmotionalClose } from '../components/EmotionalClose';
import { Footer } from '../components/Footer';
import { initMetaPixel, trackPageView } from '../utils/metaPixel';
export function SalesPage() {
  useEffect(() => {
    initMetaPixel();
    trackPageView();
  }, []);
  return <main className="min-h-screen bg-brand-cream font-body selection:bg-brand-gold/30 selection:text-brand-dark" data-id="element-317">
      {/* Meta Pixel noscript fallback */}
      <noscript data-id="element-318">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1436890408218834&ev=PageView&noscript=1" alt="" data-id="element-319" />
      </noscript>
      <HeroSection data-id="element-320" />
      <PainSection data-id="element-321" />
      <MechanismSection data-id="element-322" />
      <PainAmplification data-id="element-323" />
      <OriginStory data-id="element-324" />
      <TestimonialsSection data-id="element-325" />
      <ProductPresentation data-id="element-326" />
      <ValueStack data-id="element-327" />
      <BeforeAfter data-id="element-328" />
      <ScienceSection data-id="element-329" />
      <PricingSection data-id="element-330" />
      <GuaranteeSection data-id="element-331" />
      <UrgencySection data-id="element-332" />
      <FAQSection data-id="element-333" />
      <EmotionalClose data-id="element-334" />
      <Footer data-id="element-335" />
    </main>;
}